import styled from "@emotion/styled";
import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import { Direction } from "@/components/note/editor/top-bar/organize";
import { MDSTextField, MDSTextFieldSlotName, MDSTextFieldVariant } from "@/mds";

interface MdsDropdownSearchInputHeaderProps {
  onChange: (value: string) => void;
  onKeyDirection?: (direction: Direction) => void;
  onEscape?: () => void;
  onEnter?: () => void;
  onClear?: () => void;
  value: string;
  placeholder?: string;
}
/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const MdsDropdownSearchInputHeader = ({
  onChange,
  value,
  placeholder,
  onKeyDirection,
  onEscape,
  onEnter,
  onClear,
}: MdsDropdownSearchInputHeaderProps) => {
  return (
    <SearchInput
      variant={MDSTextFieldVariant.Form}
      onChange={onChange}
      placeholder={placeholder}
      value={value}
      autoFocus={true}
      showClearTextButton={true}
      onClearText={onClear}
      onKeyDown={e => {
        switch (e.key) {
          case "ArrowUp":
            e.preventDefault();
            onKeyDirection?.(Direction.UP);
            return true;
          case "ArrowDown":
            e.preventDefault();
            onKeyDirection?.(Direction.DOWN);
            return true;
          case "Escape":
            e.preventDefault();
            onEscape?.();
            return true;
          case "Enter":
          case "Return":
            e.preventDefault();
            onEnter?.();
            return true;
        }
      }}
    >
      <MdsIcon kind={MdsIconKind.Search} slot={MDSTextFieldSlotName.LeftAddon} />
    </SearchInput>
  );
};

const SearchInput = styled(MDSTextField)({
  border: "unset",
  backgroundColor: "transparent",
});
